import {push} from 'connected-react-router/immutable';
import {hasNoSteps, getCurrentStep} from '../reducers/fluxes';

export const CHECK_FIRST_PAGE_LOAD = 'CHECK_FIRST_PAGE_LOAD';

export const ADD_STEP = 'ADD_STEP';
export const REMOVE_STEP = 'REMOVE_STEP';

export const RESET_FLUX = 'RESET_FLUX';

export const UPDATE_FLUX_DATA = 'UPDATE_FLUX_DATA';

// TODO: is it needed?
export function checkFirstPageLoad() {
  return {
    type: CHECK_FIRST_PAGE_LOAD
  };
}

export function addStep(step, data = {}, replace = null) {
  return {
    type: ADD_STEP,
    step,
    data,
    replace
  };
}

export function removeStep(data) {
  return {
    type: REMOVE_STEP,
    data
  };
}

export function nextStep(targetLocation, data = {}, replaceCurrentStep = null) {
  return function(dispatch, getState) {
    const state = getState();
    const currentLocation = state.getIn(['router', 'location', 'pathname']);

    if (hasNoSteps(state)) {
      dispatch(addStep(currentLocation));
    }

    dispatch(addStep(targetLocation, data, replaceCurrentStep));

    dispatch(push(targetLocation));
  };
}

export function prevStep(defaultTargetLocation, data) {
  return function(dispatch, getState) {
    dispatch(removeStep(data));

    const step = getCurrentStep(getState());
    const targetLocation = step && step.get('location');
    if (targetLocation) {
      dispatch(push(targetLocation));
    } else {
      dispatch(push(defaultTargetLocation));
    }
  };
}

export function resetFlux() {
  return {
    type: RESET_FLUX
  };
}

export function updateFluxData(data) {
  return {
    type: UPDATE_FLUX_DATA,
    data
  };
}
